import {Lead, ListItem as Slot, Radio, Text, Trail, Typography} from '@logistics-frontend/blocks'
import React from 'react'

import {Props} from './PaymentCard.types'
import {PaymentSystemIcon} from './PaymentSystemIcon'

export function PaymentCard({card, onPress, checked = false}: Props): React.ReactElement {
  const {system, number, expirationDate} = card

  function clickHandler(card?: Props['card']) {
    if (card && onPress) {
      return function _clickHandler() {
        onPress(card)
      }
    }
  }

  return (
    <Slot dividerOffset="m" onPress={clickHandler(card)} size="l">
      <Lead>
        <PaymentSystemIcon paymentSystem={system} mobile />
      </Lead>
      <Text>
        <Typography variant="body2">{number}</Typography>
        {expirationDate && (
          <Typography color="minor" variant="caption1">
            {expirationDate}
          </Typography>
        )}
      </Text>
      <Trail mr="m">
        <Radio checked={checked} />
      </Trail>
    </Slot>
  )
}
